import { cacheFirstConfig, http } from '@/core/helpers/axiosHelper';
import { PaginatedResponse } from '@/core/models/PaginatedResponse';
import { ContractTemplateFieldName } from './contract-template-field-name.interface';

export class ContractTemplateFieldNameService {
   async getContractTemplateFieldNames() {
      const response = await http.get<PaginatedResponse<ContractTemplateFieldName>>(`/contract-template-field-names`, {
         ...cacheFirstConfig,
         params: { per_page: '100' },
      });
      return response.data;
   }
}
